const experienceData = [
  {
    id: "dev2",
    title: "Software Engineer Intern",
    company: "Zip Code Wilmington",
    duration: "5/2025 - Present",
    description:
      "Developed personal projects and contributed to hackathon presentations while supporting non-profit organizations and small businesses with limited access to technical resources.",
    image: "/images/zipcode.jpeg",
  },
  {
    id: "dev1",
    title: "Full Stack Software Engineer",
    company: "Zip Code Wilmington",
    duration: "2/2025 - 5/2025",
    description:
      "Completing a nationally acclaimed, highly competitive, immersive software developer training program accepting less than 12% of applicants including over 1000 hours of software development projects using Agile and Scrum methodologies and TDD, experience with multiple object-oriented programming languages and frameworks including Java, SQL, and Spring Boot.",
    image: "/images/zipcode.jpeg",
  },
  {
    id: "dev3",
    title: "Full Stack Developer",
    company: "Nucamp Coding Bootcamp",
    duration: "2/2021 - 6/2021",
    description: "Completed Full Stack MERN (MongoDB, Express, React, Node.JS) Developer program.",
    image: "/images/nucamp.png",
  },
];

const healthcareData = [
  {
    id: "job1",
    title: "Respiratory Therapist",
    company: "Nemours Children's Hospital",
    duration: "2024 - Present",
    description:
      "Provides training, education, and coaching to students, newly hired therapists, and other staff; provides asthma education to parents and family members; coordinates with different stakeholders to ensure the best outcome and practices for patients.",
    image: "/images/nemours.png",
  },
  {
    id: "job2",
    title: "Respiratory Therapist Supervisor",
    company: "Good Shepherd Penn Partners",
    duration: "2013 - Present",
    description:
      "Managed collaboration and coordination with multidisciplinary teams to ensure 100% staff satisfaction. Led tracking of equipment and supplies resulting in a 50% decrease in miscommunications and seamless collaboration between teams. Integrated ventilator data into the EPIC medical documentation systems so that the ventilator and EPIC system had real-time connectivity.",
    image: "/images/gspp.png",
  },
  {
    id: "job3",
    title: "Respiratory Therapist Manager",
    company: "Nemours Children's Hospital",
    duration: "2011 - 2016",
    description:
      "Recognized as Respiratory Therapist of the Year (2013); promoted from Charge Respiratory Therapist to Registered Respiratory Care Manager (2013) and impactfully served in this role between 2013 through 2016 before temporarily transitioning into another hospital system; returned in 2024 and continues to be relied upon by senior management at the hospital as a trusted advisor and technical subject matter expert.",
    image: "/images/nemours.png",
  },
];

const ExperienceCard = ({ item }) => (
  <div className="timeline-card d-flex gap-3 align-items-start">
    <img src={item.image} alt={item.company} className="timeline-logo mt-1" />
    <div className="flex-grow-1">
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-1">
        <div>
          <div className="timeline-title">{item.title}</div>
          <div className="timeline-company">{item.company}</div>
        </div>
        <span className="timeline-duration">{item.duration}</span>
      </div>
      <p className="timeline-desc mb-0">{item.description}</p>
    </div>
  </div>
);

const Experience = () => (
  <div>
    <div className="hero-wrap" style={{ marginBottom: "3rem" }}>
      <img src="/images/experience1-banner.png" alt="Experience Banner" />
      <div className="hero-overlay" />
      <div className="hero-content">
        <div className="hero-title">My Professional Journey</div>
      </div>
    </div>

    <div className="container pb-5">
      <h2 className="section-title">Software Engineering</h2>
      {experienceData.map((item) => (
        <ExperienceCard key={`${item.id}-${item.title}`} item={item} />
      ))}

      <hr className="section-divider" />

      <h2 className="section-title">Healthcare</h2>
      {healthcareData.map((item) => (
        <ExperienceCard key={`${item.id}-${item.title}`} item={item} />
      ))}
    </div>
  </div>
);

export default Experience;
